import { useCallback, useMemo } from "react";

import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import useCanDeleteTemplate from "shared/Templates/access/useCanDeleteTemplate";
import useCanManageTemplate from "shared/Templates/access/useCanManageTemplate";
import { BlueprintVersionedGroup } from "types/generated";

import { showCreateTemplateDrawer } from "../../CreateTemplateDrawer";
import { showDeleteConfirmation } from "../../DeleteConfirmation";

const TemplatesTableRowActionsCell = ({
  item: template,
  ...cellProps
}: TableSimpleCellProps<BlueprintVersionedGroup>) => {
  const canManageTemplate = useCanManageTemplate()(template.space.id);
  const canDeleteTemplate = useCanDeleteTemplate()(template);

  const onEditDetails = useCallback(() => {
    showCreateTemplateDrawer({ id: template.id, template });
  }, [template]);
  const menuItems = useMemo(() => {
    const items = [];

    if (canManageTemplate.result || !!canManageTemplate.message) {
      items.push(
        <DropdownMenuItem
          key="edit"
          onAction={onEditDetails}
          isDisabled={!canManageTemplate.result}
          tooltip={canManageTemplate.message}
          tooltipPlacement="left"
        >
          Edit
        </DropdownMenuItem>
      );
    }

    if (canDeleteTemplate.result || !!canDeleteTemplate.message) {
      items.push(
        <DropdownMenuItem
          key="delete"
          onAction={() => showDeleteConfirmation({ name: template.name, id: template.id })}
          danger
          isDisabled={!canDeleteTemplate.result}
          tooltip={canDeleteTemplate.message}
          tooltipPlacement="left"
        >
          Delete
        </DropdownMenuItem>
      );
    }

    return items;
  }, [canManageTemplate, canDeleteTemplate, template, onEditDetails]);

  return (
    <TableSimpleCell {...cellProps}>
      {menuItems.length > 0 && (
        <DropdownMenuEllipsis tooltip="Template actions">{menuItems}</DropdownMenuEllipsis>
      )}
    </TableSimpleCell>
  );
};

export default TemplatesTableRowActionsCell;
